import { useEffect } from "react";
import { useWebSocket } from "../context/WebSocketContext";
import { useAppContext } from "../context/AppContext";
import { logSecretly } from "../utils/logSecretly";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { WS_EVENTS } from "../constants";

/**
 * Listens for the WebSocket SESSION_ENDED event.
 * When received, it automatically logs the user out and resets the pod state,
 * returning the pod to the Welcome screen.
 */
export function useSessionEndedListener(): void {
    const { subscribe } = useWebSocket();
    const { resetState } = useAppContext();
    const { isAuthenticated, isLoggingOut } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = subscribe(WS_EVENTS.SESSION_ENDED, async (data: any) => {
            if (!isAuthenticated || isLoggingOut) {
                return;
            }
            logSecretly("Received SESSION_ENDED event, resetting pod...", data);
            resetState();
            navigate("/")
        });

        return () => unsubscribe();
    }, [subscribe, resetState, isAuthenticated, isLoggingOut]);
}
